import { render, staticRenderFns } from "./game-link.vue?vue&type=template&id=449fc827&lang=pug&"
import script from "./game-link.vue?vue&type=script&lang=js&"
export * from "./game-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports